import { render, staticRenderFns } from "./GalleryTutorial.vue?vue&type=template&id=2cb0d16c&"
import script from "./GalleryTutorial.vue?vue&type=script&lang=js&"
export * from "./GalleryTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports